import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { LifeBuoy, Phone, ExternalLink } from "lucide-react";
import { useI18n } from "@/context/I18nContext";

// Emergency & crisis lines: Germany-first (primary market) plus international fallbacks.
export const CRISIS_LINES = [
  { name: "Emergency (Germany / EU)", contact: "112", url: "" },
  { name: "Telefonseelsorge (Germany · 24/7 · free)", contact: "0800 111 0 111 · 0800 111 0 222", url: "https://www.telefonseelsorge.de" },
  { name: "988 Suicide & Crisis Lifeline (US)", contact: "Call or text 988", url: "https://988lifeline.org" },
  { name: "Crisis Text Line", contact: "Text HOME to 741741", url: "https://crisistextline.org" },
  { name: "Find a helpline worldwide", contact: "findahelpline.com", url: "https://findahelpline.com" },
];

export function CrisisResources({ open, onClose }) {
  const { t } = useI18n();
  return (
    <Dialog open={open} onOpenChange={(v) => !v && onClose?.()}>
      <DialogContent data-testid="crisis-resources-dialog" className="rounded-3xl max-w-md">
        <DialogHeader>
          <div className="mx-auto mb-2 flex h-14 w-14 items-center justify-center rounded-full bg-destructive/10">
            <LifeBuoy className="h-7 w-7 text-destructive" strokeWidth={1.5} />
          </div>
          <DialogTitle className="text-center text-2xl">{t("support.crisisTitle")}</DialogTitle>
        </DialogHeader>
        <p className="text-center text-sm text-muted-foreground leading-relaxed">
          {t("support.crisisBody")}
        </p>
        <div className="mt-2 space-y-2">
          {CRISIS_LINES.map((l) => (
            <a key={l.name} href={l.url || undefined} target={l.url ? "_blank" : undefined} rel="noreferrer"
               data-testid="crisis-line-link"
               className="flex items-center justify-between rounded-2xl border border-border bg-card p-4 transition-colors duration-300 hover:bg-accent">
              <div>
                <div className="font-medium text-sm">{l.name}</div>
                <div className="flex items-center gap-1.5 text-xs text-muted-foreground mt-0.5">
                  <Phone className="h-3 w-3" strokeWidth={1.5} /> {l.contact}
                </div>
              </div>
              {l.url && <ExternalLink className="h-4 w-4 text-muted-foreground" strokeWidth={1.5} />}
            </a>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
}
